import Money from '../svgs/money.svg';
import Business from '../svgs/business.svg';
import Hardware from '../svgs/hardware.svg';
import Nopay from '../svgs/nopay.svg';
import Ready from '../svgs/ready.svg';
import Start from '../svgs/start.svg';

export const features = [
    {
        img: Money,
        title: 'moneyTitle',
        description: 'moneyDescription'
    },
    {
        img: Hardware,
        title: 'hardwareTitle',
        description: 'hardwareDescription'
    },
    {
        img: Ready,
        title: 'readyTitle',
        description: 'readyDescription'
    },
    {
        img: Business,
        title: 'businessTitle',
        description: 'businessDescription'
    },
    {
        img: Start,
        title: 'startTitle',
        description: 'startDescription'
    },
    {
        img: Nopay,
        title: 'nopayTitle',
        description: 'nopayDescription'
    }
];

export const opportunities = [
    {
        title: 'stabilityTitle',
        description: 'stabilityDescription'
    },
    {
        title: 'kubernetesTitle',
        description: 'kubernetesDescription'
    },
    {
        title: 'vpcTitle',
        description: 'vpcDescription'
    },
    {
        title: 'aiTitle',
        description: 'aiDescription'
    }
];

export const toolsItems = [
    {
        img: 'users.webp',
        title: 'customers',
        link: '/compute',
        description: 'customersDescription',
        flag: 'customers'
    },
    {
        img: 'invoices.webp',
        title: 'invoices',
        link: '/networking',
        description: 'invoicesDescription',
        flag: 'invoices'
    },
    {
        img: 'pay.webp',
        title: 'payment',
        link: '/projects',
        description: 'paymentDescription',
        flag: 'payment'
    },
    {
        img: 'reports.webp',
        title: 'reports',
        link: '/compliance',
        description: 'reportsDescription',
        flag: 'reports'
    },
    {
        img: 'subscribe.webp',
        title: 'subscriptions',
        link: '/compliance',
        description: 'subscriptionsDescription',
        flag: 'subscriptions'
    }
];

export const infrastructure = [
    {
        title: 'infrastructureTitle',
        points: [
            'provisioning',
            'advancedTools',
            'management',
            'awsMigration'
        ]
    },
    {
        title: 'highAvailabilityTitle',
        points: [
            'replicate',
            'loadBalancing',
            'backups',
            'autonomousClouds'
        ]
    }
];
